import {
  FormLabel,
  FormLabelProps,
  forwardRef,
  InputGroup,
  NumberDecrementStepper,
  NumberIncrementStepper,
  NumberInput,
  NumberInputField,
  NumberInputFieldProps,
  NumberInputProps,
  NumberInputStepper,
  useToken,
} from '@chakra-ui/react';
import { ReactNode } from 'react';
import { ChakraFeatherIcon } from '../ChakraFeatherIcon';
import { WithFormControl, WithFormControlProps } from '../WithFormControl';

export interface NumericalInputFieldProps extends NumberInputProps {
  label: ReactNode;
  allowEmpty?: boolean;
  inputProps?: NumberInputFieldProps;
  rootProps?: WithFormControlProps;
  labelProps?: FormLabelProps;
  showSteppers?: boolean;
}

export const NumericalInputField = forwardRef<NumericalInputFieldProps, 'input'>(
  ({ label, inputProps, rootProps, labelProps, onChange, allowEmpty = false, showSteppers = true, ...props }, ref) => {
    const labelSpacing = useToken('space', 'kilo');

    const rootTitle = typeof label === 'string' ? label : undefined;

    const handleChange: NumberInputProps['onChange'] = (valueString, valueNumber) => {
      if (!allowEmpty && valueString === '') {
        onChange?.('0', 0);
        return;
      }
      onChange?.(valueString, valueNumber);
    };

    return (
      <WithFormControl variant='floating' title={rootTitle} {...rootProps}>
        <InputGroup variant='flushed' size='md'>
          <NumberInput flex={1} {...props} onChange={handleChange}>
            <NumberInputField placeholder=' ' color={'black'} ref={ref} defaultValue={props.defaultValue} {...inputProps} />

            <FormLabel isTruncated maxW={`calc(100% - ${labelSpacing})`} {...labelProps}>
              <strong>{label}</strong>
            </FormLabel>

            {showSteppers && (
              <NumberInputStepper>
                <NumberIncrementStepper border='none'>
                  <ChakraFeatherIcon name='chevron-up' color='black' boxSize='12px' />
                </NumberIncrementStepper>
                <NumberDecrementStepper border='none'>
                  <ChakraFeatherIcon name='chevron-down' color='black' boxSize='12px' />
                </NumberDecrementStepper>
              </NumberInputStepper>
            )}
          </NumberInput>
        </InputGroup>
      </WithFormControl>
    );
  },
);
